// extracted by mini-css-extract-plugin
module.exports = {"container":"breadcrumbs_container__zFR04","small-container":"breadcrumbs_small-container__BeSed"};